import { render } from "./DashboardPricingAnalysis.vue?vue&type=template&id=5b9f0b56&scoped=true"
import script from "./DashboardPricingAnalysis.vue?vue&type=script&lang=js"
export * from "./DashboardPricingAnalysis.vue?vue&type=script&lang=js"

import "./DashboardPricingAnalysis.vue?vue&type=style&index=0&id=5b9f0b56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9f0b56"]])

export default __exports__